import { Alert } from "reactstrap";
import { P } from "../../../../../AbstractElements";
import { useState } from "react";

export const AlertsWithIcons = () => {
    const [visible, setVisible] = useState(true);
    const onDismiss = () => setVisible(false);
    return (
      <Alert color="primary" isOpen={visible} toggle={onDismiss} fade>
        <i className="icofont icofont-heart-alt"></i>
        <P>Good Morning! Start your day with some alerts.</P>
      </Alert>
    );
  };